import { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Chip,
} from "@mui/material";
import { BaseSteelGradesCell } from "components/common/plan/BaseSteelGradesCell";
import {
  ImpuritiesPlot,
  ImpuritiesPlotSkeleton,
} from "components/common/plots/ImpuritiesPlotByTenant";
import { toImpuritiesConstraint } from "components/common/plots/ImpuritiesPlotCommon";
import { useTenantTranslation } from "hooks/formatters";
import { FixedMixImpurities, SteelGrade } from "store/api/generatedApi";

export const FixedMixGradeCell = ({
  steelGrades,
  selectedSteelGradeIds,
  chemistry,
  loading,
}: {
  steelGrades: SteelGrade[];
  selectedSteelGradeIds: number[];
  chemistry: FixedMixImpurities[];
  loading: boolean;
}) => {
  const { t } = useTenantTranslation();
  const [plottedGradeId, setPlottedGradeId] = useState<number | null>(null);
  const grade = steelGrades.find((grade) => grade.id === plottedGradeId);
  const impurities = chemistry.find(
    (preview) => preview.steel_grade_name === grade?.name
  )?.impurities;
  const close = () => {
    setPlottedGradeId(null);
  };
  return (
    <>
      <BaseSteelGradesCell
        steelGrades={steelGrades}
        selectedSteelGradeIds={selectedSteelGradeIds}
        focusedSteelGradeId={plottedGradeId}
        onClick={setPlottedGradeId}
      />
      <Dialog
        open={grade !== undefined}
        onClose={close}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>{grade?.name}</DialogTitle>
        <DialogContent>
          <Stack direction="row" gap={1} sx={{ mb: 2, flexWrap: "wrap" }}>
            {steelGrades.map((grade) => (
              <Chip
                key={grade.id}
                label={grade.name}
                color={grade.id === plottedGradeId ? "primary" : "default"}
                onClick={() => {
                  setPlottedGradeId(grade.id);
                }}
              />
            ))}
          </Stack>
          {loading ? (
            <ImpuritiesPlotSkeleton height={330} />
          ) : impurities == null ? (
            <Alert severity="error">{t("errorLoadingPlot")}</Alert>
          ) : impurities.length > 0 ? (
            <ImpuritiesPlot
              constraints={impurities.map(toImpuritiesConstraint)}
              height={330}
            />
          ) : (
            <Alert severity="info">{t("noData")}</Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={close}>{t("close")}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
